
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '@/components/ui/dialog';
import { TariffSelectionDialog as CoreTariffDialog } from '@/pages/courier/TariffSelectionDialog';

// Обертка для обратной совместимости
interface TariffDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  amoCustomerCode?: string | null;
  amoDealCode?: string | null;
  clientNumber?: string | null;
}

export function TariffSelectionDialog(props: TariffDialogProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent className="relative overflow-hidden bg-gradient-to-br from-gray-900 via-slate-900 to-slate-950 text-white rounded-3xl p-0 shadow-[0_0_60px_2px_#2e0357b0]">
        <DialogHeader className="px-6 py-4">
          <DialogTitle className="text-white">Выбор тарифа</DialogTitle>
          <DialogDescription className="text-gray-300">
            Выберите подходящий тариф для аренды
          </DialogDescription>
        </DialogHeader>
        <div className="w-full h-full px-4 sm:px-6 py-8 sm:py-10 rounded-lg relative overflow-auto">
          <CoreTariffDialog {...props} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
